"use client"

import { useQuery, gql } from "@apollo/client"

export const GET_REVIEWS_QUERY = gql`
  query ReviewsData($category_id: String, $currentPage: Int!, $pageSize: Int!) {
    allReviews(
      filter: { category_id: { eq: $category_id } }
      currentPage: $currentPage
      pageSize: $pageSize
    ) {
      items {
        id
        product {
          name
          uid
          url_key
          small_image {
            url(width: 400, height: 400)
            __typename
          }
        }
        nickname
        summary
        text
        created_at
        review_image {
          id
          url
          __typename
        }

        average_rating
      }
      page_info {
        page_size
        current_page
        total_pages
      }
      total_count
    }
  }
`

const useAboutReviews = () => {
  const { data } = useQuery(GET_REVIEWS_QUERY, {
    variables: {
      category_id: "0",
      currentPage: 1,
      pageSize: 8,
    },
  })

  const { allReviews } = data || {}

  const { items: allReviewsItems, total_count: reviewsCount } = allReviews || {
    items: [],
  }

  return {
    reviewsCount,
    reviews: allReviews?.items ?? [],
  }
}

export default useAboutReviews
